

// Main regions available in the form
export const REGIONS = [
  "NCR 1",
  "NCR 2",
  "NCR 3",
  "North Luzon",
  "Central Luzon",
  "South Luzon", 
  "Visayas",
  "Mindanao",
  "Siargao"
];

// Complete region configuration with all data
export const REGION_CONFIG = {
  
  // North NCR Region
  "NCR 1": {
    id: "north-ncr",
    title: "MERCHANT LOCATION - NORTH NCR 1",
    description: "Please provide the location details",
    formFields: {
      province: "province_ncr",
      municipality: "municipality_ncr",
      mall_type: "mall_type_ncr",
      description: "description_north_ncr",
      mall_name: "north_ncr_mall_name"
    },
    provinces: [
      "METRO MANILA"

    ],
    municipalities: [
      "QUEZON CITY",
      "SAN JUAN CITY",
      "CALOOCAN CITY",
      "MALABON CITY",
      "NAVOTAS CITY",
      "VALENZUELA CITY",
      "MANILA CITY"
    ],
    malls: [
      "168 Shopping Mall",
      "999 Shopping Mall - Caloocan",
      "999 Shopping Mall - Manila",
      "Ayala Malls Fairview Terraces",
      "Ayala Malls Vertis North",
      "Araneta Square Mall",
      "Crossroad Park Tandang Sora",
      "Eastwood Mall",
      "Eton Centris",
      "Fairview Center Mall",
      "Fisher Mall Malabon",
      "Fisher Mall Quezon Avenue",
      "Gateway Mall",
      "Greenhills Shopping Center",
      "Happy Go Shopping Mall",
      "Isetann Recto",
      "Lucky Chinatown",
      "Malabon City Square",
      "One Mall Valenzuela",
      "Opus",
      "Robinsons Galleria Ortigas",
      "Robinsons Magnolia QC",
      "Robinsons Manila",
      "Robinsons Novaliches",
      "Robinsons Otis",
      "Robinson Town Mall Malabon",
      "Robinson Townville Regalado",
      "The Cloverleaf",
      "Trinoma",
      "Tutuban Center Mall",
      "U.P. Town Center",
      "Victory Plaza",
      "WalterMart North Edsa",
      "Zabarte Town Center",
      "Others"
    ],
    routes: {
      mall: "north-ncr-malls",
      nonMall: "merchant-location"
    }
  },
  
  // Rizal NCR Region
  "NCR 2": {
    id: "rizal-ncr",
    title: "MERCHANT LOCATION - NORTH NCR 2",
    description: "Please provide the location details",
    formFields: {
      province: "province_rizal",
      municipality: "municipality_rizal",
      mall_type: "mall_type_rizal",
      description: "description_rizal_ncr",
      mall_name: "rizal_ncr_mall_name"
    },
    provinces: [
      "METRO MANILA", 
      // "Metro Manila"
      
    ],
    municipalities: [
      "ALABANG",
      "LAS PIÑAS CITY",
      "MAKATI CITY",
      "MUNTINLUPA CITY",
      "PASAY CITY",
      "PARAÑAQUE CITY"
    ],
    malls: [
      "Alabang Town Center",
      "Ayala Malls Manila Bay",
      "Circuit",
      "Evia Las Piñas",
      "Festival Mall Muntinlupa",
      "Glorietta",
      "Greenbelt",
      "Molito Lifestyle Center",
      "Newport City",
      "One Ayala",
      "Parqal",
      "Power Plant Makati",
      "Westgate Mall",
      "Others",
    ],
    routes: {
      mall: "rizal-ncr-malls",
      nonMall: "merchant-location"
    }
  },
  
  // South NCR Region
  "NCR 3": {
    id: "south-ncr",
    title: "MERCHANT LOCATION - NORTH NCR 3",
    description: "Please provide the location details",
    formFields: {
      province: "province_south_ncr",
      municipality: "municipality_south_ncr",
      mall_type: "mall_type_south_ncr",
      description: "description_south_ncr",
      mall_name: "south_ncr_mall_name"
    },
    provinces: [
      "METRO MANILA", 
      "RIZAL"
    ],
    municipalities: {
      "METRO MANILA": [
        "MANDALUYONG CITY",
        "MARIKINA CITY",
        "PASIG CITY",
        "PATEROS",
        "TAGUIG CITY",
        "OTHERS"
      ],
      "RIZAL": [
        "ANGONO",
        "ANTIPOLO CITY",
        "BARAS",
        "BINANGONAN",
        "CAINTA",
        "CARDONA",
        "JALA JALA",
        "MORONG",
        "PILILLA",
        "PLAZA ALDEA",
        "RODRIGUEZ (MONTALBAN)",
        "SAN ISIDRO",
        "SAN MATEO",
        "SAN ROQUE",
        "TANAY",
        "TAYTAY",
        "TERESA",
        "OTHERS"
      ]
    },
    malls: [
      "Ayala Malls Feliz",
      "Ayala Malls The 30th",
      "Bonifacio High Street",
      "Market! Market!",
      "Mitsukoshi Mall BGC",
      "One Bonifacio High Street",
      "Park Triangle",
      // "Park Triangle",
      "Shangri-La Plaza",
      "Uptown Mall BGC",
      "Venice Grand Canal Mall",
      "Others"
    ],
    routes: {
      mall: "south-ncr-malls",
      nonMall: "merchant-location"
    }
  },

  // North Luzon Region
  "North Luzon": {
    id: "north-luzon",
    title: "MERCHANT LOCATION - NORTH LUZON",
    description: "Please provide the location details",
    formFields: {
      province: "province",
      municipality: "municipality",
      mall_type: "mall_type",
      description: "description_north_luzon",
      mall_name: "north_luzon_mall_name"
    },
    provinces: [
      "AURORA",
      "ABRA",
      "APAYAO",
      "BATANES",
      "BENGUET",
      "CAGAYAN",
      "IFUGAO",
      "ILOCOS NORTE",
      "ILOCOS SUR",
      "ISABELA",
      "KALINGA",
      "LA UNION",
      "MOUNTAIN PROVINCE",
      "NUEVA VIZCAYA",
      "PANGASINAN",
      "QUIRINO",
      // "TARLAC"
    ],
    municipalities: {
      // AURORA
      "AURORA":[
      "BALER",
      "DILASAG",
      "MARIA AURORA",
      "OTHERS"
      ],
      // ABRA
      "ABRA":[
      "BANGUED",
      "PIDIGAN",
      "SAN QUINTIN",
      "OTHERS"
      ],
      // APAYAO
      "APAYAO":[
      "LUNA",
      "OTHERS"
      ],
      // BATANES
      "BATANES":[
      "BASCO",
      "OTHERS"
      ],
      //BENGUET
      "BENGUET":[
      "ATOK",
      "BAGUIO CITY",
      "LA TRINIDAD",
      "TUBA",
      "OTHERS"
      ],
      // CAGAYAN
      "CAGAYAN":[
      "ABULUG",
      "ALLACAPAN",
      "AMULUNG",
      "APARRI",
      "BAGGAO",
      "BALLESTEROS",
      "CAMALANIUGAN",
      "CLAVERIA",
      "IGUIG",
      "LAL LO",
      "SANCHEZ MIRA",
      "SANTA ANA",
      "SOLANA",
      "TUAO",
      "TUGUEGARAO",
      "OTHERS"
      ],
      // IFUGAO
      "IFUGAO":[
      "LAMUT",
      "OTHERS"
      ],
      //ILOCOS NORTE
      "ILOCOS NORTE":[
      "BACARRA",
      "BANGUI",
      "BATAC",
      "BURGOS",
      "CURRIMAO",
      "DINGRAS",
      "LAOAG",
      "PAGUDPUD",
      "PAOAY",
      "PASUQUIN",
      "PINILI",
      "SAN FRANCISCO",
      "SAN MIGUEL",
      "SAN NICOLAS",
      "OTHERS"
      ],
      //ILOCOS SUR
      "ILOCOS SUR":[
      "BANTAY",
      "CABUGAO",
      "CANDON",
      "GALIMUYOD",
      "MAGSINGAL",
      "NARVACAN",
      "SAN ESTEBAN",
      "SAN ILDEFONSO",
      "SAN JUAN",
      "SAN VICENTE",
      "SANTA",
      "SANTA CRUZ",
      "SANTA LUCIA",
      "SANTA MARIA",
      "SANTIAGO",
      "SANTO DOMINGO",
      "SINAIT",
      "TAGUDIN",
      "VIGAN",
      "OTHERS"
      ],
      //ISABELA
      "ISABELA":[
      "ALICIA",
      "AURORA",
      "CABAGAN",
      "CABATUAN",
      "CAUAYAN",
      "CORDON",
      "ECHAGUE",
      "GAMU",
      "ILAGAN",
      "LUNA",
      "NAGUILIAN",
      "RAMON",
      "ROXAS",
      "SAN AGUSTIN",
      "SAN ISIDRO",
      "SAN MANUEL",
      "SAN MATEO",
      "SANTIAGO",
      "TUMAUINI",
      "OTHERS"
      ],
      //KALINGA
      "KALINGA":[
      "RIZAL (LIWAN)",
      "TABUK",
      "OTHERS"
      ],
      //LA UNION
      "LA UNION":[
      "AGOO",
      "ARINGAY",
      "BACNOTAN",
      "BALAOAN",
      "BANGAR",
      "BAUANG",
      "CABA",
      "LUNA",
      "NAGUILIAN",
      "PUGO",
      "ROSARIO",
      "SAN FERNANDO",
      "SAN GABRIEL",
      "SAN JUAN",
      "SANTO TOMAS",
      "SUDIPEN",
      "TUBAO",
      "OTHERS"
      ],
      //PANGASINAN
      "PANGASINAN":[
      "URDANETA CITY",
      "DAGUPAN CITY",
      "ROSALES",
      "CALASIAO",
      "ALAMINOS CITY",
      "SAN CARLOS CITY",
      "OTHERS"
      ],
      //MOUNTAIN PROVINCE
      "MOUNTAIN PROVINCE":[
      "BAUKO",
      "NATONIN",
      "SAGADA",
      "OTHERS"
      ],
      //NUEVA VIZCAYA
      "NUEVA VIZCAYA":[
      "ALFONSO CASTAÑEDA",
      "ARITAO",
      "BAMBANG",
      "BAYOMBONG",
      "SOLANO",
      "OTHERS"
      ],
      //PANGASINAN
      "PANGASINAN":[
      "AGNO",
      "AGUILAR",
      "ALAMINOS",
      "ALCALA",
      "ASINGAN",
      "BANI",
      "BAUTISTA",
      "BAYAMBANG",
      "BINALONAN",
      "BINMALEY",
      "BOLINAO",
      "BUGALLON",
      "CALASIAO",
      "DAGUPAN",
      "DASOL",
      "INFANTA",
      "LABRADOR",
      "LAOAC",
      "LINGAYEN",
      "MALASIQUI",
      "MANAOAG",
      "MANGALDAN",
      "MANGATAREM",
      "POZORRUBIO",
      "ROSALES",
      "SAN CARLOS",
      "SAN FABIAN",
      "SAN JACINTO",
      "SAN NICOLAS",
      "SAN QUINTIN",
      "SANTA BARBARA",
      "SANTA MARIA",
      "SANTO TOMAS",
      "SUAL",
      "TAYUG",
      "UMINGAN",
      "URDANETA",
      "VILLASIS",
      "OTHERS"
      ],
      //QUIRINO
      "QUIRINO":[
      "CABARROGUIS",
      "MADDELA",
      "SAGUDAY",
      "OTHERS"
      ],
      //TARLAC
      // "TARLAC":[
      // "TARLAC CITY",
      // "CONCEPCION",
      // "CAPAS",
      // "PANIQUI",
      // "VICTORIA",
      // "OTHERS"
      // ],
      //AURORA
      // "AURORA":[
      // "BALER, AURORA",
      // "OTHERS"
      // ],
    }, 
    malls: [
      "CSI Mall Dagupan",
      "Marquee Mall", 
      "Robinsons Starmills",
      "Others"
    ],
    routes: {
      mall: "north-luzon-malls",
      nonMall: "merchant-location"
    }
  },


   // Central Luzon Region
  "Central Luzon": {
    id: "central-luzon",
    title: "MERCHANT LOCATION - CENTRAL LUZON",
    description: "Please provide the location details",
    formFields: {
      province: "province",
      municipality: "municipality",
      mall_type: "mall_type",
      description: "description_north_luzon",
      mall_name: "north_luzon_mall_name"
    },
    provinces: [
      "BATAAN",
      "BULACAN",
      "NUEVA ECIJA",
      "PAMPANGA",
      "TARLAC",
      "ZAMBALES",
      // "ILOCOS NORTE"

    ],
    municipalities: {
      //BATAAN
      "BATAAN":[
      "ABUCAY",
      "BAGAC",
      "BALANGA",
      "DINALUPIHAN",
      "HERMOSA",
      "LIMAY",
      "MARIVELES",
      "MORONG",
      "ORANI",
      "ORION",
      "PILAR",
      "SAMAL",
      "TANAUAN",
      "OTHERS"
      ],
      //BULACAN
      "BULACAN":[
      "ANGAT",
      "BALAGTAS (BIGAA)",
      "BALIUAG",
      "BOCAUE",
      "BULAKAN",
      "BUSTOS",
      "CALUMPIT",
      "CRUZ",
      "GUIGUINTO",
      "HAGONOY",
      "MALOLOS",
      "MARILAO",
      "MEYCAUAYAN",
      "NORZAGARAY",
      "OBANDO",
      "PANDI",
      "PLARIDEL",
      "PULILAN",
      "SAN ILDEFONSO",
      "SAN JOSE DEL MONTE",
      "SAN MIGUEL",
      "SAN RAFAEL",
      "STA MARIA",
      "OTHERS"
      ],
      //NUEVA ECIJA
      "NUEVA ECIJA":[
      "ALIAGA",
      "BONGABON",
      "CABANATUAN",
      "CABIAO",
      "CUYAPO",
      "GAPAN",
      "GENERAL TINIO (PAPAYA)",
      "GUIMBA",
      "JAEN",
      "LICAB",
      "LUPAO",
      "MUNOZ",
      "PALAYAN",
      "PANTABANGAN",
      "PENARANDA",
      "RIZAL",
      "SAN ANTONIO",
      "SAN ISIDRO",
      "SAN JOSE",
      "SAN LEONARDO",
      "SANTA ROSA",
      "SANTO DOMINGO",
      "TALAVERA",
      "TALUGTUG",
      "ZARAGOZA",
      "OTHERS"
      ],
      //PAMPANGA
      "PAMPANGA":[
      "ANGELES",
      "APALIT",
      "ARAYAT",
      "BACOLOR",
      "CANDABA",
      "CLARK",
      "DINALUPIHAN",
      "FLORIDABLANCA",
      "GUAGUA",
      "LUBAO",
      "MABALACAT",
      "MACABEBE",
      "MAGALANG",
      "MEXICO",
      "MINALIN",
      "PORAC",
      "SAN AGUSTIN",
      "SAN FERNANDO",
      "SAN JOSE",
      "SAN LUIS",
      "SAN SIMON",
      "SANTA ANA",
      "SANTA RITA",
      "SANTO ROSARIO",
      "SANTO TOMAS",
      "OTHERS"
      ],
      //TARLAC
      "TARLAC":[
      "BAMBAN",
      "CAMILING",
      "CAPAS",
      "CONCEPCION",
      "GERONA",
      "LA PAZ",
      "LUISITA",
      "MAYANTOC",
      "MONCADA",
      "PANIQUI",
      "PURA",
      "SAN CLEMENTE",
      "SAN MANUEL",
      "SAN MIGUEL",
      "SAN NICOLAS",
      "SAN ROQUE",
      "SANTA IGNACIA",
      "TARLAC CITY",
      "VICTORIA",
      "OTHERS"
      ],
      //ZAMBALES
      "ZAMBALES":[
      "BOTOLAN",
      "CABANGAN",
      "CANDELARIA",
      "CASTILLEJOS",
      "IBA",
      "MASINLOC",
      "OLONGAPO",
      "SAN ANTONIO",
      "SAN FELIPE",
      "SAN MARCELINO",
      "SAN NARCISO",
      "SANTA CRUZ",
      "SUBIC",
      "OTHERS"
      ],

    }, 
    malls: [
      "CSI Mall Dagupan",
      "Marquee Mall", 
      "Robinsons Starmills",
      "Others"
    ],
    routes: {
      mall: "north-luzon-malls",
      nonMall: "merchant-location"
    }
  },


  // South Luzon Region
  "South Luzon": {
    id: "south-luzon",
    title: "MERCHANT LOCATION - SOUTH LUZON",
    description: "Please provide the location details",
    formFields: {
      province: "province_south_luzon",
      municipality: "municipality_south_luzon",
      mall_type: "mall_type_south_luzon",
      description: "description_south_luzon",
      mall_name: "south_luzon_mall_name"
    },
    provinces: [
      "ALBAY",
      "BATANGAS",
      "CAMARINES NORTE",
      "CAMARINES SUR",
      "CATANDUANES",
      "CAVITE",
      "LAGUNA",
      "MARINDUQUE",
      "MASBATE",
      "OCCIDENTAL MINDORO",
      "ORIENTAL MINDORO",
      "PALAWAN",
      "QUEZON",
      "ROMBLON",
      "SORSOGON"
    ],
     municipalities: {
    // ALBAY
    "ALBAY":[
      "BACACAY",
      "CAMALIG",
      "DARAGA",
      "GUINOBATAN",
      "LEGAZPI",
      "LIGAO",
      "MALILIPOT",
      "NAGA",
      "PIO DURAN",
      "POLANGUI",
      "SANTO DOMINGO",
      "TABACO",
      "TIWI",
    "OTHERS"
    ],
    // BATANGAS
    "BATANGAS":[
    "AGONCILLO",
    "ALITAGTAG",
    "BALAYAN",
    "BALETE",
    "BATANGAS CITY",
    "BAUAN",
    "CALACA",
    "CALAPAN",
    "CALATAGAN",
    "CUENCA",
    "IBAAN",
    "LAUREL",
    "LEMERY",
    "LIAN",
    "LIPA",
    "LOBO",
    "MABINI",
    "MALVAR",
    "MATAASNAKAHOY",
    "NASUGBU",
    "PADRE GARCIA",
    "ROSARIO",
    "SAN JOSE",
    "SAN JUAN",
    "SAN PASCUAL",
    "SANTO TOMAS",
    "STA TERESITAS",
    "TAAL",
    "TALISAY",
    "TANAUAN",
    "TAYSAN",
    "TERESITA",
    "TUY",
    "OTHERS",
    ],
    // CAMARINES NORTE
    "CAMARINES NORTE":[
    "DAET",
    "J PANGANIBAN",
    "LABO",
    "SANTA ELENA",
    "TALISAY",
    "OTHERS"
    ],
    // CAMARINES SUR
    "CAMARINES SUR":[
    "BAAO",
    "BATO",
    "BUHI",
    "CALABANGA",
    "CANAMAN",
    "CARAMOAN",
    "GOA",
    "IRIGA",
    "LAGONOY",
    "LIBMANAN",
    "MAGARAO",
    "MILAOR",
    "MINALABAC",
    "NABUA",
    "NAGA",
    "OCAMPO",
    "PAMPLONA",
    "PILI",
    "SAGNAY",
    "SAN FERNANDO",
    "SAN JOSE",
    "SAN VICENTE",
    "SIPOCOT",
    "TIGAON",
    "TINAMBAC",
    "OTHERS"
    ],
    // CATANDUANES
    "CATANDUANES":[
    "PANDAN",
    "SAN ANDRES",
    "VIRAC",
    "OTHERS"
    ],
    // CAVITE
    "CAVITE":[
    "ALFONSO",
    "AMADEO",
    "BACOOR",
    "CARMONA",
    "CAVITE CITY",
    "DASMARIÑAS",
    "GENERAL EMILIO AGUINALDO",
    "GENERAL MARIANO ALVAREZ",
    "GENERAL TRIAS",
    "IMUS",
    "INDANG",
    "KAWIT",
    "MAGALLANES",
    "MARAGONDON",
    "MENDEZ (MENDEZ-NUÑEZ)",
    "NAIC",
    "NOVELETA",
    "ROSARIO",
    "SILANG",
    "TAGAYTAY",
    "TANZA",
    "TERNATE",
    "TRECE MARTIRES",
    "OTHERS"
    ],
    // LAGUNA
    "LAGUNA":[
    "ALAMINOS",
    "BAY",
    "BIÑAN",
    "CABUYAO",
    "CALAMBA",
    "CALAUAN",
    "CAVINTI",
    "FAMY",
    "KALAYAAN",
    "LILIW",
    "LOS BAÑOS",
    "LUMBAN",
    "MAGDALENA",
    "MAJAYJAY",
    "NAGCARLAN",
    "PAETE",
    "PAGSANJAN",
    "PAKIL",
    "PILA",
    "RIZAL",
    "SAN PABLO",
    "SAN PEDRO",
    "SANTA CRUZ",
    "SANTA ROSA",
    "SINILOAN",
    "VICTORIA",
    "OTHERS"
    ],
    // MARINDUQUE
    "MARINDUQUE":[
    "BOAC",
    "SANTA CRUZ",
    "OTHERS"
    ],
    // MASBATE
    "MASBATE":[
    "AROROY",
    "BALUD",
    "CATAINGAN",
    "MASBATE CITY",
    "SAN JACINTO",
    "SAN PASCUAL",
    "OTHERS"
    ],
    // OCCIDENTAL MINDORO
    "OCCIDENTAL MINDORO":[
    "MAGSAYSAY",
    "MAMBURAO",
    "SABLAYAN",
    "SAN JOSE",
    "OTHERS"
    ],
    // ORIENTAL MINDORO
    "ORIENTAL MINDORO":[
    "BONGABONG",
    "CALAPAN",
    "GLORIA",
    "MINDORO",
    "NAUJAN",
    "PINAMALAYAN",
    "PUERTO GALERA",
    "ROXAS",
    "SOCORRO",
    "VICTORIA",
    "OTHERS"
    ],
    // PALAWAN
    "PALAWAN":[
    "BATARAZA",
    "BROOKES POINT",
    "BUSUANGA",
    "CORON CITY",
    "CULION",
    "EL NIDO",
    "NARRA",
    "PUERTO PRINCESA",
    "QUEZON",
    "RIZAL",
    "ROXAS",
    "SAN VICENTE",
    "SOFRONIO ESP",
    "TAYTAY",
    "OTHERS"
    ],
    // QUEZON
    "QUEZON":[
    "ATIMONAN",
    "BURGOS",
    "CALAUAG",
    "CANDELARIA",
    "CATANAUAN",
    "DOLORES",
    "GUMACA",
    "INFANTA",
    "LOPEZ",
    "LUCBAN",
    "LUCENA",
    "MAUBAN",
    "PAGBILAO",
    "REAL",
    "SAMPALOC",
    "SAN ANTONIO",
    "SAN FRANCISCO",
    "SARIAYA",
    "TAGKAWAYAN",
    "TAYABAS",
    "TIAONG",
    "UNISAN",
    "OTHERS"
    ],
    // ROMBLON
    "ROMBLON":[
    "CALATRAVA",
    "LONOS",
    "LOOC",
    "ODIONGAN",
    "SAN ANDRES",
    "OTHERS"
    ],
    // SORSOGON
    "SORSOGON":[
    "BACON",
    "BULAN",
    "CASIGURAN",
    "CASTILLA",
    "GUBAT",
    "IROSIN",
    "MAGALLANES",
    "MATNOG",
    "PILAR",
    "SORSOGON CITY",
    "OTHERS"
    ],

  },
    malls: [
      "Ayala Malls Legazpi",
      "Ayala Malls Serin",
      "Ayala Malls Solenad",
      "Robinsons Galleria South",
      "Robinsons Naga",
      "Robinsons Palawan",
      "Robinsons Place Lipa",
      "Vermosa",
      "Others"
    ],
    routes: {
      mall: "south-luzon-malls",
      nonMall: "merchant-location"
    }
  },
  
  // Visayas Region
  "Visayas": {
    id: "visayas",
    title: "MERCHANT LOCATION - VISAYAS",
    description: "Please provide the location details",
    formFields: {
      province: "province_visayas",
      municipality: "municipality_visayas",
      mall_type: "mall_type_visayas",
      description: "description_visayas",
      mall_name: "visayas_mall_name"
    },
    provinces: [
      "AKLAN",
      "ANTIQUE",
      "BILIRAN",
      "BOHOL",
      "CAPIZ",
      "CEBU",
      "EASTERN SAMAR",
      "GUIMARAS",
      "ILOILO",
      "LEYTE",
      "NEGROS OCCIDENTAL",
      "NEGROS ORIENTAL",
      "NORTHERN SAMAR",
      "SAMAR (WESTERN SAMAR)",
      "SIQUIJOR",
      "SOUTHERN LEYTE",
    ],
    municipalities: {
    // AKLAN
    "AKLAN": [
    "BANGA",
    "BURUANGA",
    "IBAJAY",
    "KALIBO",
    "MAKATO",
    "MALAY",
    "N WASHINGTON",
    "NABAS",
    "NUMANCIA",
    "TANGALAN",
    "OTHERS"
    ],
    // ANTIQUE
    "ANTIQUE": [
    "BUGASONG",
    "CULASI",
    "HAMTIC",
    "PANDAN",
    "PATNONGON",
    "SAN JOSE DE BUENAVISTA",
    "SIBALOM",
    "OTHERS"
    ],
    // BILIRAN
    "BILIRAN": [
    "CULABA",
    "NAVAL",
    "OTHERS"
    ],
    // BOHOL
    "BOHOL": [
    "ANDA",
    "BACLAYON",
    "BALILIHAN",
    "BILAR",
    "CALAPE",
    "CARMEN",
    "CATIGBIAN",
    "CORELLA",
    "CORTES",
    "DANAO",
    "DAUIS",
    "DIMIAO",
    "GUINDULMAN",
    "INABANGA",
    "JAGNA",
    "LILA",
    "LOAY",
    "LOBOC",
    "LOON",
    "MABINI",
    "PANGLAO",
    "SAGBAYAN",
    "SIERRA BULLONES",
    "TAGBILARAN",
    "TALIBON",
    "TUBIGON",
    "UBAY",
    "VALENCIA",
    "OTHERS"
    ],
    // CAPIZ
    "CAPIZ": [
    "CUARTERO",
    "DUMALAG",
    "DUMARAO",
    "IVISAN",
    "MAMBUSAO",
    "PANAY",
    "PONTEVEDRA",
    "ROXAS",
    "SIGMA",
    "OTHERS"
    ],
    // CEBU
    "CEBU": [
    "ALANGALANG",
    "ALCANTARA",
    "ALOGUINSAN",
    "ARGAO",
    "BADIAN",
    "BALAMBAN",
    "BANILAD",
    "BANTAYAN",
    "BARILI",
    "BOGO",
    "BORBON",
    "CARCAR",
    "CARMEN",
    "CATMON",
    "CEBU CITY",
    "COMPOSTELA",
    "CONSOLACION",
    "CORDOVA",
    "DAANBANTAYAN",
    "DALAGUETE",
    "DANAO",
    "DUMANJUG",
    "GINATILAN",
    "GUADALUPE",
    "LAHUG",
    "LAPU-LAPU (OPON)",
    "LILOAN",
    "MABOLO",
    "MACTAN",
    "MADRIDEJOS",
    "MAMBALING",
    "MANDAUE",
    "MEDELLIN",
    "MINGLANILLA",
    "MOALBOAL",
    "NAGA",
    "OSLOB",
    "PINAMUNGAJAN",
    "RONDA",
    "SAMBOAN",
    "SAN FERNANDO",
    "SAN FRANCISCO",
    "SAN REMIGIO",
    "SANTA FE",
    "SANTANDER",
    "SIBONGA",
    "SOGOD",
    "SOUTH COASTAL",
    "TABUELAN",
    "TALISAY",
    "TANJAY",
    "TOLEDO",
    "TUBURAN",
    "OTHERS"
    ],
    // EASTERN SAMAR
    "EASTERN SAMAR": [
    "ARTECHE",
    "BALANGKAYAN",
    "BORONGAN",
    "DOLORES",
    "GUIUAN",
    "TAFT",
    "OTHERS"
    ],
    // GUIMARAS
    "GUIMARAS": [
    "BUENAVISTA",
    "JORDAN",
    "NUEVA VALENCIA",
    "SAN LORENZO",
    "OTHERS"
    ],
    // ILOILO
    "ILOILO": [
    "AJUY",
    "ALIMODIAN",
    "BALASAN",
    "BANATE",
    "BAROTAC NUEVO",
    "BAROTAC VIEJO",
    "CABATUAN",
    "CALINOG",
    "CARLES",
    "CONCEPCION",
    "DUMANGAS",
    "ESTANCIA",
    "GUIMBAL",
    "ILOILO CITY",
    "JANIUAY",
    "JARO",
    "LA PAZ",
    "LAMBUNAO",
    "LEGANES",
    "MAASIN",
    "MANDURRIAO",
    "MIAGAO",
    "OTON",
    "PASSI",
    "PAVIA",
    "POTOTAN",
    "SAN JOAQUIN",
    "SAN MIGUEL",
    "SANTA BARBARA",
    "SARA",
    "TIGBAUAN",
    "ZARRAGA",
    "OTHERS"
    ],
    // LEYTE
    "LEYTE": [
    "ABUCAY",
    "ABUYOG",
    "ALANGALANG",
    "ALBUERA",
    "BATO",
    "BAYBAY",
    "BURAUEN",
    "CAPOOCAN",
    "CARIGARA",
    "DAGAMI",
    "DULAG",
    "HILONGOS",
    "INOPACAN",
    "ISABEL",
    "KANANGA",
    "MACARTHUR",
    "MATALOM",
    "MERIDA",
    "ORMOC",
    "PALO",
    "PALOMPON",
    "POBLACION",
    "SAN MIGUEL",
    "SOGOD",
    "TACLOBAN",
    "TANAUAN",
    "TOLOSA",
    "VILLABA",
    "OTHERS"
    ],
    // NEGROS OCCIDENTAL
    "NEGROS OCCIDENTAL": [
    "BACOLOD",
    "BAGO",
    "BENEDICTO",
    "BINALBAGAN",
    "CADIZ",
    "CALATRAVA",
    "CAUAYAN",
    "ENRIQUE MAG",
    "ESCALANTE",
    "HIMAMAYLAN",
    "HINIGARAN",
    "HINOBA AN",
    "ILOG",
    "ISABELA",
    "KABANKALAN",
    "LA CARLOTA",
    "LA CASTELLANA",
    "MANAPLA",
    "MURCIA",
    "PONTEVEDRA",
    "SAGAY",
    "SAN CARLOS",
    "SAN ENRIQUE",
    "SIATON",
    "SILAY",
    "SIPALAY",
    "TALISAY",
    "TOBOSO",
    "VALLADOLID",
    "VICTORIAS",
    "OTHERS"
    ],
    // NEGROS ORIENTAL
    "NEGROS ORIENTAL": [
        "AMLAN",
        "AYUNGON",
        "BACONG",
        "BAIS",
        "BAYAWAN",
        "CANLAON",
        "DAUIN",
        "DUMAGUETE",
        "ESCALANTE",
        "GUIHULNGAN",
        "MABINAY",
        "SAN JOSE",
        "SANTA CATALINA",
        "SIATON",
        "SIBULAN",
        "TANJAY",
        "VALENCIA",
        "ZAMBOANGUITA",
        "OTHERS"
    ],
    // NORTHERN SAMAR
    "NORTHERN SAMAR": [
    "ALLEN",
    "CATARMAN",
    "MONDRAGON",
    "SAN ROQUE",
    "OTHERS"
    ],
    // SAMAR (WESTERN SAMAR)
    "SAMAR (WESTERN SAMAR)": [
    "BASEY",
    "CALBAYOG",
    "CATBALOGAN",
    "SAN JORGE",
    "OTHERS"
    ],
    // SIQUIJOR
    "SIQUIJOR": [
    "LARENA",
    "LAZI",
    "MARIA",
    "SAN JUAN",
    "SIQUIJOR",
    "OTHERS"
    ],
    // SOUTHERN LEYTE
    "SOUTHERN LEYTE": [
    "BONTOC",
    "HINUNANGAN",
    "LIBAGON",
    "LILOAN",
    "MAASIN",
    "PADRE BURGOS",
    "PINTUYAN",
    "SAINT BERNARD",
    "SOGOD",
    "OTHERS"
    ],
    },
    malls: [
      "Ayala Center Cebu", 
      "Boracay Station 2Robinsons Place Iloilo",
      "Il Corso",
      "NuStar",
      "Robinsons Galleria Cebu",
      "Others"
    ],
    routes: {
      mall: "visayas-malls",
      nonMall: "merchant-location"
    }
  },
  
  // Mindanao Region
  "Mindanao": {
    id: "mindanao",
    title: "MERCHANT LOCATION - MINDANAO",
    description: "Please provide the location details",
    formFields: {
      province: "province_mindanao",
      municipality: "municipality_mindanao",
      mall_type: "mall_type_mindanao",
      description: "description_mindanao",
      mall_name: "mindanao_mall_name"
    },
    provinces: [
      "AGUSAN DEL NORTE",
      "AGUSAN DEL SUR",
      "BASILAN",
      "BUKIDNON",
      "CAMIGUIN",
      "COTABATO",
      "DAVAO DE ORO",
      "DAVAO DEL NORTE",
      "DAVAO DEL SUR",
      "DAVAO OCCIDENTAL",
      "DAVAO ORIENTAL",
      "LANAO DEL NORTE",
      "LANAO DEL SUR",
      "MAGUINDANAO",
      "MISAMIS OCCIDENTAL",
      "MISAMIS ORIENTAL",
      "SARANGANI",
      "SOUTH COTABATO",
      "SULTAN KUDARAT",
      "SURIGAO DEL NORTE",
      "SURIGAO DEL SUR",
      "ZAMBOANGA DEL NORTE",
      "ZAMBOANGA DEL SUR",
      "ZAMBOANGA SIBUGAY"
    ],
    municipalities: {
    // AGUSAN DEL NORTE
    "AGUSAN DEL NORTE": [
    "BUENAVISTA",
    "BUTUAN",
    "CABADBARAN",
    "MAGALLANES",
    "NASIPIT",
    "SANTIAGO",
    "OTHERS",
    ],
    // AGUSAN DEL SUR
    "AGUSAN DEL SUR": [
    "BAYUGAN",
    "PROSPERIDAD",
    "SAN FRANCISCO",
    "TRENTO",
    "OTHERS",
    ],
    // BASILAN
    "BASILAN": [
    "ISABELA",
    "OTHERS",
    ],
    // BUKIDNON
    "BUKIDNON": [
    "DANGCAGAN",
    "DON CARLOS",
    "KIBAWE",
    "MALAYBALAY",
    "MANOLO FORTICH",
    "MARAMAG",
    "PANGANTUCAN",
    "QUEZON",
    "TALAKAG",
    "VALENCIA",
    "OTHERS",
    ],
    // CAMIGUIN
    "CAMIGUIN": [
    "MAHINOG",
    "MAMBAJAO",
    "GUINSIBIBAN",
    "SAGAY",
    "CATARMAN",
    "OTHERS",
    ],
    // COTABATO
    "COTABATO": [
    "ANTIPAS",
    "KABACAN",
    "KIDAPAWAN",
    "LIBUNGAN",
    "MAKILALA",
    "MIDSAYAP",
    "M'LANG",
    "PIGCAWAYAN",
    "SURALLAH",
    "OTHERS",
    ],
    // DAVAO DE ORO
    "DAVAO DE ORO": [
    "COMPOSTELA",
    "MACO",
    "MARAGUSAN",
    "MONKAYO",
    "MONTEVISTA",
    "NABUNTURAN",
    "PANTUKAN",
    "OTHERS",
    ],
    // DAVAO DEL NORTE
    "DAVAO DEL NORTE": [
    "CARMEN",
    "IGACOS CITY",
    "KAPALONG",
    "NEW CORELLA",
    "PANABO",
    "SAMAL",
    "SANTO TOMAS",
    "TAGUM",
    "TALOMO",
    "OTHERS",
    ],
    // DAVAO DEL SUR"
    "DAVAO DEL SUR": [
    "BAJADA",
    "BANSALAN",
    "DAVAO CITY",
    "DIGOS",
    "HAGONOY",
    "MAASIN",
    "PADADA",
    "SANTA CRUZ",
    "SANTA MARIA",
    "TAGUM",
    "OTHERS",
    ],
    // DAVAO OCCIDENTAL
    "DAVAO OCCIDENTAL": [
    "MALITA",
    "OTHERS",
    ],
    // DAVAO ORIENTAL
    "DAVAO ORIENTAL": [ 
    "BAGANGA",  
    "BANAY BANAY",  
    "CATEEL", 
    "GOV GENEROSO", 
    "LUPON",  
    "MATI", 
    "TARRAGONA",
    "OTHERS",
    ],
    // LANAO DEL NORTE
    "LANAO DEL NORTE": [
    "ILIGAN",
    "KAPATAGAN",
    "KOLAMBUGAN",
    "LALA",
    "LINAMON",
    "MAIGO",
    "MARAWI",
    "TAGOLOAN",
    "TUBOD",
    "OTHERS",
    ],
    // LANAO DEL SUR
    "LANAO DEL SUR": [
    "WAO",
    "OTHERS",
    ],
    // MAGUINDANAO
    "MAGUINDANAO": [
    "COTABATO CITY",
    "DATU PAGLAS",
    "DATU PIANG",
    "DINAIG",
    "ODIN SINSUAT",
    "OTHERS",
    ],
    // MISAMIS OCCIDENTAL
    "MISAMIS OCCIDENTAL": [
    "BONIFACIO",
    "CALAMBA",
    "CLARIN",
    "JIMENEZ",
    "MISAMIS",
    "OROQUIETA",
    "OZAMIZ",
    "PLARIDEL",
    "QROQUIETA",
    "TANGUB",
    "OTHERS",
    ],
    "MISAMIS ORIENTAL": [
    "ALUBIJID",
    "BALINGASAG",
    "BALINGOAN",
    "CAGAYAN DE ORO",
    "CAGAYANCILLO",
    "CLAVERIA",
    "EL SALVADOR",
    "GINGOOG",
    "INITAO",
    "JASAAN",
    "LAGUINDINGAN",
    "LIBERTAD",
    "LUGAIT",
    "MANTICAO",
    "MEDINA",
    "NAAWAN",
    "OPOL",
    "PSB EL SALVADOR",
    "TAGOLOAN",
    "VILLANUEVA",
    "OTHERS",
    ],
    "SARANGANI": [
    "ALABEL",
    "GLAN",
    "KIAMBA",
    "LABEL",
    "OTHERS",
    ],
    "SOUTH COTABATO": [
    "BANGA",
    "GENERAL SANTOS (DADIANGAS)",
    "KORONADAL",
    "LAKE SEBU",
    "POLOMOLOK",
    "SAN MIGUEL",
    "SANTO NIÑO",
    "SURALLAH",
    "TAMPAKAN",
    "TUPI",
    "OTHERS",
    ],
    "SULTAN KUDARAT": [
    "BAGUMBAYAN",
    "ESPERANZA",
    "ISULAN",
    "TACURONG",
    "OTHERS",
    ],
    "SURIGAO DEL NORTE": [
    "ALEGRIA",
    "CLAVER",
    "DAPA",
    "DEL CARMEN",
    "GENERAL LUNA",
    "PLACER",
    "SURIGAO CITY",
    "OTHERS",
    ],
    "SURIGAO DEL SUR": [
    "BAROBO",
    "BISLIG",
    "LINGIG",
    "MADRID",
    "SAN AGUSTIN",
    "TAGO",
    "TANDAG",
    "OTHERS",
    ],
    "ZAMBOANGA DEL NORTE": [
    "DAPITAN",
    "DIPOLOG",
    "LABASON",
    "LILOY",
    "POLANCO",
    "SERGIO OSMENA",
    "SINDANGAN",
    "SIRAWAI",
    "OTHERS",
    ],
    "ZAMBOANGA DEL SUR": [
    "AURORA",
    "DUMALINAO",
    "GUIWAN",
    "MAHAYAG",
    "MIDSALIP",
    "MOLAVE",
    "PAGADIAN",
    "SAN MIGUEL",
    "SAN PABLO",
    "TAMBULIG",
    "ZAMBOANGA",
    "OTHERS",
    ],
    "ZAMBOANGA SIBUGAY": [
    "BUUG",
    "IMELDA",
    "IPIL",
    "KABASALAN",
    "OTHERS",
    ],
    
    },
    malls: [
      "Abreeza",
      "Centrio Mall",
      "Others"
    ],
    routes: {
      mall: "mindanao-malls",
      nonMall: "merchant-location"
    }
  },



  // Mindanao Region
  "Siargao": {
    id: "siargao",
    title: "MERCHANT LOCATION - SIARGAO",
    description: "Please provide the location details",
    formFields: {
      province: "province_siargao",
      municipality: "municipality_siargao",
      mall_type: "mall_type_siargao",
      description: "description_siargao",
      mall_name: "siargao_mall_name"
    },
    provinces: [
      "GENERAL LUNA",
    ],
    municipalities: {
      "GENERAL LUNA": [
      "OTHERS"
    ]
    },
    malls: [
      "Abreeza",
      "C3 Mall", 
      "Centrio Mall",
      "Limketkai Center",
      "Robinsons Davao",
      "Others"
    ],
    routes: {
      mall: "mindanao-malls",
      nonMall: "merchant-location"
    }
  }
};


export const getRegionConfig = (regionName) => {
  return REGION_CONFIG[regionName] || null;
};


export const getMallsByRegion = (regionName) => {
  const region = REGION_CONFIG[regionName];
  return region ? region.malls : [];
};
